import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetItem extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Item</h1>
				<p>This method returns information about the specified item in BrickLink catalog.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> {`/items/{type}/{no}`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> type </td>
							<td> String </td>
							<td> N </td>
							<td> The type of the item to get. Acceptable values are:<br/>MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> no </td>
							<td> String </td>
							<td> N </td>
							<td> Identification number of the item to get </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Example</h4>
				<ul>
					<li>
						GET /items/part/1234
						<ul>
							<li>Retrieves PART #1234</li>
						</ul>
					</li>
					<li>
						GET /items/set/1-1
						<ul>
							<li>Retrieves SET #1-1</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}